@switch (status) {
  @case (RequisitionStatus.Draft) {
    <rt-badge
      [text]="'app.requisitions.status.draft' | translate"
      [color]="'counter-default'"
    ></rt-badge>
  }
  @case (RequisitionStatus.Pending) {
    <rt-badge
      [text]="'app.requisitions.status.pending' | translate"
      [color]="isArchived ? 'counter-default' : 'requested-tint'"
      iconName="timer-sand"
    ></rt-badge>
  }
  @case (RequisitionStatus.Rejected) {
    <rt-badge
      [text]="'app.requisitions.status.rejected' | translate"
      [color]="isArchived ? 'counter-default' : 'rejected-tint'"
      iconName="block"
    ></rt-badge>
  }
  @case (RequisitionStatus.Approved) {
    <rt-badge
      [text]="'app.requisitions.status.approved' | translate"
      [color]="isArchived ? 'counter-default' : 'success-tint'"
      iconName="check"
    ></rt-badge>
  }
  @case (RequisitionStatus.Filled) {
    <rt-badge
      [text]="'app.requisitions.status.filled' | translate"
      [color]="isArchived ? 'counter-default' : 'success-tint'"
      iconName="hired"
    ></rt-badge>
  }
}
